// extracted by mini-css-extract-plugin
export default {"chart":"chart_chart__TjeuV","title":"chart_title__bVhF3","chartGrid":"chart_chartGrid__PwRlC"};